import React, { useState } from 'react';
import logo from 'assets/images/icons/logo_white.svg';
import * as yup from 'yup';
import { each } from 'lodash';
import { useFormik } from 'formik';
import { HiOutlineMail } from 'react-icons/hi';
import Form from 'partial/components/form';
import Button from 'partial/components/Button';
import FormInput from 'partial/components/form/FormInput';
import FormPassword from 'partial/components/form/FormPassword';
import { useLogin } from '../hooks';
import { useConfirmMfaOtp } from '../modals/ConfirmMFA';
import { useMFA } from '../modals/SetupMFA';

const initialValues = {
  email: '',
  password: '',
};

const validationSchema = yup.object().shape({
  email: yup.string().email('Invalid').required('Required'),
  password: yup.string().required('Required'),
});

function Landing() {
  const [isLoading, login] = useLogin();
  const setupMFA = useMFA();
  const openMfa = useConfirmMfaOtp();
  const [validateOnChange, setValidateOnChange] = useState(false);
  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (form, { setFieldError }) => {
      setValidateOnChange(true);
      login(
        form,
        () => {}, // onSuccess
        (err) => {
          each(err, (v, k) => {
            setFieldError(k, v);
          });
        },
        () => openMfa(values.email),
        (cb) => setupMFA(cb),
      );
    },
    validateOnChange,
  });
  return (
    <div className="min-h-screen grid grid-cols-12">
      <div className="col-span-7 bg-landing flex">
        <img src={logo} alt="logo" className="m-auto" />
      </div>
      <div className="col-start-9 col-end-12 p-10 flex flex-col gap-12 justify-center relative">
        <div>
          <h3 className="heading-3 text-primary-700">SIGN IN</h3>
          <p className="paragraph !mt-1 text-2xl">It&apos;s nice to see you!</p>
        </div>
        <Form onSubmit={handleSubmit} error={errors} noValidate>
          <div className="flex flex-col items-center gap-2 text-sm">
            <div className="w-full">
              <FormInput
                icon={HiOutlineMail}
                name="email"
                onSetFieldValue={setFieldValue}
                value={values.email}
                type="email"
                error={errors.email}
                label="Email"
                labelClassName="!uppercase"
              />
            </div>
            <div className="w-full relative mt-3">
              <FormPassword
                name="password"
                label="Password"
                onSetFieldValue={setFieldValue}
                value={values.password}
                error={errors.password}
                noAutoFill
              />
              {/* <div className="absolute left-0 text-primary font-bold text-xs mt-2 mr-1">
                <a href="/">Forgot Password?</a>
              </div> future enhancements */}
            </div>
            <Button
              size="sm"
              primary
              type="submit"
              className="h-[40px] uppercase w-full mt-10"
              disabled={isLoading}
            >
              sign in
            </Button>
          </div>
        </Form>
        <div className="absolute bottom-0 inset-x-0 mb-3">
          <div className="heading-container text-xs space-y-1">
            <p>Administrator Portal - TxtBox Core</p>
            <p>&copy; Copyright 2022 | v2.0.0</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
